export function createRoutes() {
  return [
    {
      path: 'accounts',
      component: () => import(/* webpackChunkName: "UserChrome" */'./UserChrome.vue'),
      children: [
        {
          path: '/',
          name: 'userListChrome',
          component: () => import(/* webpackChunkName: "UserList" */'./UserList.vue'),
        },
        {
          path: 'create',
          name: 'createUserChrome',
          component: () => import(/* webpackChunkName: "UserRegistration" */'./UserRegistration.vue'),
        },
        {
          path: ':accountId',
          name: 'userEditChrome',
          component: () => import(/* webpackChunkName: "UserEdit" */'./UserEdit.vue'),
        },
      ],
    },
  ];
}
